import '~/styles/bundles/templates/article.css';
